import React, { useState, useEffect, useContext, useRef } from "react";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import { API, baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import { type } from "jquery";
import useAuthHelper from "../../helpers/AuthHelper";
import { useTranslation } from "react-i18next";

function NewFactureRecurrentes() {
  const { onlyCommercial, hadAddAccess } = useAuthHelper();
  const navigate = useNavigate();
  const { organisation } = useContext(OrgContext);
  const { user } = useContext(AuthContext);

  const [clients, setClients] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [products, setProducts] = useState([]);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  const [summaryTotatlHt, setSummaryTotatlHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotatlTtc] = useState(0);

  const [client, setClient] = useState([]);
  const [title, setTitle] = useState("");
  const [frequency, setFrequency] = useState("");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState("");
  const [isActive, setIsActive] = useState(false);

  const [productId, setProductId] = useState();
  const [qty, setQty] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [tva, setTva] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [totalTtc, setTotalTtc] = useState(0);
  const [details, setDetails] = useState("");

  const leTotalHt = useRef(0);
  const leTotalTTc = useRef(0);

  const [invoiceType, setInvoiceType] = useState("");

  const [taxes, setTaxes] = useState([]);
  const [selectedTaxe, setSelectedTaxe] = useState(null);
  const [selectedDepotId, setSelectedDepotId] = useState(null);
  const [qtyMaximale, setQtyMaximale] = useState(0);
  const [t, i18n] = useTranslation();

  const MAX_TITLE_LENGTH = 255;

  useEffect(() => {
    onlyCommercial();
    hadAddAccess();
    getAllAssociatedProducts();
  }, []);
  useEffect(() => {
    console.log(selectedTaxe);
    console.log(taxes);
  }, [selectedTaxe]);
  const getAllAssociatedClients = async () => {
    const response = await axios
      .get(baseURL + `/client/getbyuser/${user.id}/client/${organisation.id}`)
      .then((response) => {
        setClients(
          response.data.data.map((client) => ({
            value: client.id,
            label: client.companyName,
          })),
        );
      })
      .catch((error) => console.log("Error fetching clients:", error));
  };

  const getAllAssociatedSuppliers = async () => {
    const response = await axios
      .get(
        baseURL +
          `/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`,
      )
      .then((response) => {
        setSuppliers(
          response.data.data.map((supplier) => ({
            value: supplier.id,
            label: supplier.companyName,
          })),
        );
      })
      .catch((error) => console.log("Error fetching suppliers:", error));
  };

  const getAllAssociatedProducts = async () => {
    const response = await axios
      .get(baseURL + `/product/getbyuser/${user.id}/${organisation.id}`)
      .then((response) => {
        setProducts(
          response.data.data.map((product) => ({
            value: product.id,
            label: product.name,
            qty: product.qty,
            isService: product?.type === "Marchandise" ? false : true,
            depot: product.depot,
          })),
        );
      })
      .catch((error) => console.log("Error fetching products:", error));
  };

  const getAllAssociatedAccounts = async () => {
    const response = await axios
      .get(baseURL + `/data/user/accounts/${organisation.id}`)
      .then((response) => {
        setProducts(
          response.data.data.map((account) => ({
            value: account.id,
            label: `${account.name} - ${account.code}`,
          })),
        );
      })
      .catch((error) => console.log("Error fetching accounts:", error));
  };

  const fetchTaxes = async () => {
    const response = await axios
      .get(baseURL + `/data/organisation_taxes/${organisation.id}`)
      .then((response) => {
        const filteredTaxes = response.data.data.filter(
          (tax) =>
            tax.tax_type === "fournisseur" &&
            (tax.is_default_tax === 1 ||
              tax.organisation_id === organisation.id),
        );
        setTaxes(
          filteredTaxes.map((tax) => ({
            value: tax.id,
            label: `${tax.name} - ${tax.code}`,
            rate: tax.rate,
          })),
        );
      })
      .catch((error) => console.log("Error fetching taxes:", error));
  };

  const calcInvoiceSummary = (invoiceProducts) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;

    invoiceProducts.forEach((product) => {
      totalHt += parseFloat(product.totalHt);
      totalTva += parseFloat(product.totalTtc) - parseFloat(product.totalHt);
      totalTtc += parseFloat(product.totalTtc);
    });

    setSummaryTotatlHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotatlTtc(totalTtc);
  };

  const generateReference = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let reference = "";
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      reference += characters[randomIndex];
    }
    return reference;
  };

  const addNewProductToInvoice = () => {
    if (invoiceType === "depense") {
      if (!productId || !totalHt || !selectedTaxe || !details) {
        toast.warning(t("All fields are required!"), { theme: "colored" });
        return;
      }

      const newAccount = {
        account_id: productId.value,
        name: productId.label,
        qty: 1, // Default quantity for depense
        unitPrice: totalHt,
        tva: selectedTaxe.rate,
        tva_id: selectedTaxe.code, // Ensure tva_id is included
        totalHt,
        totalTtc:
          parseFloat(totalHt) +
          (parseFloat(totalHt) * parseFloat(selectedTaxe.rate)) / 100,
        details,
      };

      setInvoiceProductsState([...invoiceProductsState, newAccount]);
      calcInvoiceSummary([...invoiceProductsState, newAccount]);
      resetProductForm();
      closeProductModal();
    } else {
      if (
        !productId ||
        qty <= 0 ||
        unitPrice <= 0 ||
        leTotalHt.current.value <= 0 ||
        leTotalTTc.current.value <= 0
      ) {
        toast.warning(t("All fields are required!"), { theme: "colored" });
        return;
      }

      const newProduct = {
        product_id: productId.value,
        name: productId.label,
        qty,
        unitPrice,
        tva,
        totalHt: leTotalHt.current.value,
        totalTtc: leTotalTTc.current.value,
        details,
        depot_id: selectedDepotId,
        reference: generateReference(),
      };

      setInvoiceProductsState([...invoiceProductsState, newProduct]);
      calcInvoiceSummary([...invoiceProductsState, newProduct]);
      resetProductForm();
      closeProductModal();
    }
  };

  const openProductModal = () => {
    resetProductForm(); // Reset the product form fields
    const offcanvasElement = document.getElementById("offcanvasBottom");
    if (offcanvasElement) {
      offcanvasElement.classList.add("show");
      offcanvasElement.style.visibility = "visible";
      offcanvasElement.style.transform = "translateY(0%)";
    }
  };

  const closeProductModal = () => {
    const offcanvasElement = document.getElementById("offcanvasBottom");
    if (offcanvasElement) {
      offcanvasElement.classList.remove("show");
      offcanvasElement.style.visibility = "hidden";
      offcanvasElement.style.transform = "translateY(100%)";
    }
  };

  const resetProductForm = () => {
    setProductId(null);
    setQty(0);
    setUnitPrice(0);
    setTva(0);
    setTotalHt(0);
    setTotalTtc(0);
    setDetails("");
    setSelectedTaxe(null);
    setSelectedDepotId(null);
    setQtyMaximale(0);
  };

  const saveRecurringInvoice = async () => {
    if (title.trim().length > MAX_TITLE_LENGTH) {
      toast.error(
        t(`Le titre ne doit pas dépasser ${MAX_TITLE_LENGTH} caractères.`),
        {
          position: "top-right",
          autoClose: 5000,
          theme: "colored",
        },
      );
      return;
    }
    if (
      !client.value ||
      !title ||
      !frequency ||
      !startDate ||
      !invoiceProductsState.length
    ) {
      toast.error(t("All fields are required!"), { theme: "colored" });
      return;
    }

    if (invoiceType === "depense" && (!selectedTaxe || !selectedTaxe.value)) {
      toast.error(t("A valid TVA must be selected for depense!"), {
        theme: "colored",
      });
      return;
    }

    const preparedProducts = invoiceProductsState.map((product) => {
      if (invoiceType === "depense") {
        return {
          account_id: product.account_id,
          tva_id: product.tva_id, // Ensure tva_id is included
          total_ht: product.totalHt,
          total_ttc: product.totalTtc,
          tva: product.tva,
          details: product.details,
        };
      } else {
        return {
          product_id: product.product_id,
          type: product.isService ? "service" : "product",
          qty: product.qty,
          price_unit_ht: product.unitPrice,
          total_ht: product.totalHt,
          total_ttc: product.totalTtc,
          tva: product.tva,
          details: product.details,
          reference: product.reference,
          depot_id: product.depot_id,
        };
      }
    });

    const data = {
      organisation_id: organisation.id,
      user_id: user.id,
      client_id: client.value,
      title,
      frequency,
      type: invoiceType,
      start_date: startDate,
      due_date: startDate,
      end_date: endDate,
      is_active: isActive,
      total_ht: summaryTotatlHt,
      total_ttc: summaryTotatlTtc,
      total_tva: summaryTotalTva,
      products: preparedProducts,
    };

    try {
      const response = await axios.post(
        baseURL + "/data/recurring-invoices",
        data,
      );
// console.log(response)
//       if (response.data?.data.status === false) {
//         toast.error(
//           response.data?.data.message || "Échec d'ajout de la facture.",
//           { position: "top-right", autoClose: 5000, theme: "colored" },
//         );
//         return;
//       };
      // if (response.data?.data.status === true) {
        Swal.fire(
          t("Success"),
          t("Recurring invoice created successfully!"),
          "success",
        );
      // }
      navigate("/factures_recurrentes");
    } catch (error) {
      console.log("Error saving recurring invoice:", error);
      Swal.fire(t("Error"), t("Failed to create recurring invoice."), "error");
    }
  };
  const [depotProduct, setDepotProduct] = useState([]);
  const getProductData = async (selectedProduct) => {
    setQty(0); // Reset quantity
    setProductId(selectedProduct);

    const response = await axios
      .get(baseURL + `/product/get/${selectedProduct.value}`)
      .then((response) => {
        const productData = response.data.data[0];
        setUnitPrice(productData.sellingPrice);
        setTva(productData.taxe_vente.rate);
        setDepotProduct(productData.depot);
        if (selectedProduct.isService) {
          setQty(1); // Default quantity for services
        }
      })
      .catch((error) => console.log("Error fetching product data:", error));
  };

  useEffect(() => {
    if (invoiceType === "vente") {
      getAllAssociatedClients();
      getAllAssociatedProducts();
    } else if (invoiceType === "achat") {
      getAllAssociatedSuppliers();
      getAllAssociatedProducts();
    } else if (invoiceType === "depense") {
      getAllAssociatedSuppliers();
      getAllAssociatedAccounts(); // Fetch accounts instead of products
    }
  }, [invoiceType]);

  useEffect(() => {
    fetchTaxes();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="main-container container-fluid">
        <GoBack route="/factures_recurrentes" />
        <div className="page-header">
          <h1 className="page-title">Nouvelle Facture Récurrente</h1>
        </div>
        <div className="card">
          <div className="card-body">
            {/* Step 1: Select Invoice Type */}
            <div className="form-group">
              <label>Type de Facture*</label>
              <select
                className="form-control"
                value={invoiceType}
                onChange={(e) => setInvoiceType(e.target.value)}
              >
                <option value="">Sélectionner le type de facture</option>
                <option value="vente">Vente</option>
                <option value="achat">Achat</option>
                <option value="depense">Dépense</option>
              </select>
            </div>

            {/* Step 2: Show Client or Supplier List Based on Type */}
            {invoiceType === "vente" && (
              <div className="form-group">
                <label>Choisir le client*</label>
                <Select
                  options={clients}
                  onChange={(choice) => setClient(choice)}
                />
              </div>
            )}
            {(invoiceType === "achat" || invoiceType === "depense") && (
              <div className="form-group">
                <label>Choisir le fournisseur*</label>
                <Select
                  options={suppliers}
                  onChange={(choice) => setClient(choice)} // Reuse client state for suppliers
                />
              </div>
            )}

            {/* Step 3: Show Invoice Details Only After Type is Selected */}
            {invoiceType && (
              <>
                <hr />
                <h4>Informations sur la facture</h4>
                <hr />
                <div className="form-group">
                  <label>Titre*</label>
                  <input
                    id="invoiceTitle"
                    type="text"
                    placeholder="Titre"
                    className="form-control"
                    value={title}
                    // maxLength={MAX_TITLE_LENGTH}
                    onChange={(e) => setTitle(e.target.value)}
                    // aria-invalid={objet.length > MAX_TITLE_LENGTH}
                    aria-describedby="invoice-title-help"
                  />
                  <small
                    id="invoice-title-help"
                    className={
                      title.length > MAX_TITLE_LENGTH
                        ? "text-danger"
                        : "text-muted"
                    }
                  >
                    {title.length}/{MAX_TITLE_LENGTH} caractères maximum
                  </small>
                </div>
                <div className="form-group">
                  <label>Fréquence</label>
                  <select
                    className="form-control"
                    value={frequency}
                    onChange={(e) => setFrequency(e.target.value)}
                  >
                    <option value="">Sélectionner la fréquence</option>
                    <option value="daily">Quotidienne</option>
                    <option value="weekly">Hebdomadaire</option>
                    <option value="monthly">Mensuelle</option>
                    <option value="yearly">Annuelle</option>
                  </select>
                </div>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label>Date de début</label>
                    <input
                      type="date"
                      className="form-control"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label>Date d'échéance</label>
                    <input
                      type="date"
                      className="form-control"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
                <div>
                  <label className="custom-control custom-checkbox-md">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      name="example-checkbox5"
                      checked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                    />
                    <span className="custom-control-label">
                      {"Activer cette facture récurrente"}
                    </span>
                  </label>
                </div>
                <hr />
                <h5>Produits/Services</h5>
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Details</th>
                      <th scope="col">Quantité</th>
                      <th scope="col">Prix Unitaire</th>
                      <th scope="col">TVA %</th>
                      <th scope="col">Total HT</th>
                      <th scope="col">Total TTC</th>
                      <th scope="col"></th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceProductsState.map((product) => (
                      <tr key={product.product_id}>
                        <td>
                          {product.name} - {product.details}
                        </td>
                        <td>{product.qty}</td>
                        <td>{product.unitPrice}</td>
                        <td>{product.tva}%</td>
                        <td>{product.totalHt}</td>
                        <td>{product.totalTtc}</td>
                        <td>
                          <i
                            onClick={() =>
                              setInvoiceProductsState(
                                invoiceProductsState.filter(
                                  (p) => p.product_id !== product.product_id,
                                ),
                              )
                            }
                            className="fe fe-trash"
                          ></i>
                        </td>
                        <td>
                          <i
                            data-bs-toggle="offcanvas"
                            aria-controls="offcanvasBottom"
                            data-bs-target="#offcanvasBottom"
                            onClick={() => {
                              openProductModal();
                              setProductId({
                                value: product.product_id,
                                label: product.name,
                              });
                              setSelectedDepotId(parseInt(product.depot_id));
                              setQty(product.qty);
                              setUnitPrice(product.unitPrice);
                              setTva(product.tva);
                              setDetails(product.details);
                              const productDepot =
                                products.find(
                                  (p) =>
                                    !p.isService &&
                                    p.value === product.product_id,
                                )?.depot || [];

                              console.log(productDepot);
                              setDepotProduct(productDepot);
                            }}
                            className="fe fe-edit"
                          ></i>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <center>
                  <button
                    className="btn btn-primary off-canvas btn-sm mb-1"
                    type="button"
                    onClick={openProductModal}
                  >
                    <i className="fe fe-plus"></i> Add Product
                  </button>
                </center>

                <div
                  className="offcanvas offcanvas-bottom addProductCanvas"
                  tabIndex="-1"
                  id="offcanvasBottom"
                  aria-labelledby="offcanvasBottomLabel"
                >
                  <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvasBottomLabel">
                      {invoiceType === "depense"
                        ? "Ajouter un compte de dépense"
                        : "Ajouter un produit"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close text-reset"
                      onClick={closeProductModal}
                      aria-label="Close"
                    >
                      <i className="fe fe-x fs-18"></i>
                    </button>
                  </div>
                  <div className="offcanvas-body">
                    <form>
                      <div className="form-row">
                        <div className="col-xl-12 mb-3">
                          <label>
                            {invoiceType === "depense"
                              ? "Compte de dépense*"
                              : "Produit*"}
                          </label>
                          <Select
                            options={products}
                            value={productId}
                            onChange={(choice) => getProductData(choice)}
                          />
                        </div>
                        {invoiceType === "depense" ? (
                          <>
                            <div className="col-xl-12 mb-3">
                              <label>Désignation*</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                value={details}
                                onChange={(e) => setDetails(e.target.value)}
                              ></textarea>
                            </div>
                            <div className="col-xl-12 mb-3">
                              <label>Total HT*</label>
                              <input
                                type="number"
                                className="form-control"
                                value={totalHt}
                                onChange={(e) =>
                                  setTotalHt(parseFloat(e.target.value) || 0)
                                }
                              />
                            </div>
                            <div className="col-xl-12 mb-3">
                              <label>TVA*</label>
                              <Select
                                options={taxes}
                                value={selectedTaxe}
                                onChange={(choice) => setSelectedTaxe(choice)}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-xl-12 mb-3">
                              {depotProduct?.length > 0 && (
                                <>
                                  <label htmlFor="productDepots">
                                    {"Dépôts disponibles"}
                                  </label>
                                  {depotProduct?.map((depot, index) => (
                                    <div key={index} className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        id={`depot-${index}`}
                                        value={depot.depot_id}
                                        checked={
                                          selectedDepotId == depot.depot_id
                                        }
                                        name="productDepot"
                                        onChange={(e) => {
                                          setSelectedDepotId(e.target.value);
                                          setQtyMaximale(depot.quantity);
                                          console.log(
                                            "productDepot",
                                            e.target.value,
                                          );
                                        }}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`depot-${index}`}
                                      >
                                        {depot.depot.name}
                                      </label>
                                    </div>
                                  ))}
                                </>
                              )}
                            </div>
                            <div className="col-xl-3 mb-3">
                              <label>Quantité*</label>
                              <input
                                type="number"
                                className="form-control"
                                value={qty}
                                onChange={(e) => {
                                  const value = parseFloat(e.target.value) || 0;
                                  if (
                                    value > qtyMaximale &&
                                    invoiceType == "vente"
                                  ) {
                                    toast.warning(
                                      `La quantité doit être inférieure ou égale à ${qtyMaximale}.`,
                                      { theme: "colored" },
                                    );
                                    return;
                                  }
                                  setQty(value);
                                  const totalHt = value * unitPrice;
                                  const totalTtc =
                                    totalHt + (totalHt * tva) / 100;
                                  setTotalHt(totalHt.toFixed(2));
                                  setTotalTtc(totalTtc.toFixed(2));
                                }}
                              />
                            </div>
                            <div className="col-xl-3 mb-3">
                              <label>Prix Unitaire HT*</label>
                              <input
                                type="number"
                                className="form-control"
                                value={unitPrice}
                                onChange={(e) => {
                                  const value = parseFloat(e.target.value) || 0;
                                  setUnitPrice(value);
                                  const totalHt = qty * value;
                                  const totalTtc =
                                    totalHt + (totalHt * tva) / 100;
                                  setTotalHt(totalHt.toFixed(2));
                                  setTotalTtc(totalTtc.toFixed(2));
                                }}
                              />
                            </div>
                            <div className="col-xl-3 mb-3">
                              <label>Total HT*</label>
                              <input
                                type="text"
                                className="form-control"
                                value={totalHt}
                                ref={leTotalHt}
                                readOnly
                              />
                            </div>
                            <div className="col-xl-3 mb-3">
                              <label>Total TTC*</label>
                              <input
                                type="text"
                                className="form-control"
                                value={totalTtc}
                                ref={leTotalTTc}
                                readOnly
                              />
                            </div>
                            <div className="col-xl-12 mb-3">
                              <label>Détails*</label>
                              <textarea
                                className="form-control"
                                rows="3"
                                value={details}
                                onChange={(e) => setDetails(e.target.value)}
                              ></textarea>
                            </div>
                          </>
                        )}
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={addNewProductToInvoice}
                      >
                        {invoiceType === "depense"
                          ? "Ajouter le compte"
                          : "Ajouter le produit"}
                      </button>
                    </form>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-6"></div>
                  <div className="col-md-6 d-flex flex-row-reverse">
                    <div className="row">
                      <div className="invoiceSummary">
                        <table>
                          <tr>
                            <td className="invoiceSummary-base">Total HT :</td>
                            <td>
                              {Number(summaryTotatlHt).toFixed(2)}{" "}
                              {organisation?.currency?.code}
                            </td>
                          </tr>
                          <tr>
                            <td className="invoiceSummary-base">Total TVA :</td>
                            <td>
                              {Number(summaryTotalTva).toFixed(2)}{" "}
                              {organisation?.currency?.code}
                            </td>
                          </tr>
                          <tr>
                            <td className="invoiceSummary-base">Total TTC :</td>
                            <td>
                              {Number(summaryTotatlTtc).toFixed(2)}{" "}
                              {organisation?.currency?.code}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  className="btn btn-primary"
                  onClick={saveRecurringInvoice}
                >
                  Enregistrer
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default NewFactureRecurrentes;
